import {ONE_TIME} from "../Constants/PaymentTypes";
import OneTimePayment from "./OneTime/OneTimePayment";
import RecurringPayment from "./RecurringPayment";

const PaymentMethodSwitch = ({control, name, paymentType})=>{
    if (paymentType === ONE_TIME){
        return <OneTimePayment control={control} name={name}/>;
    }

    return <RecurringPayment control={control} name={name}/>;
}

export default PaymentMethodSwitch;